import { render } from "./PeriodSelector.vue?vue&type=template&id=584c39d6&scoped=true"
import script from "./PeriodSelector.vue?vue&type=script&lang=js"
export * from "./PeriodSelector.vue?vue&type=script&lang=js"

import "./PeriodSelector.vue?vue&type=style&index=0&id=584c39d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584c39d6"]])

export default __exports__